import z from "zod";

export const CreateInvoiceSchema = z.object({
    client_id: z.string().min(1, "Client must be selected").nullable(),
    supplier_id: z.string().min(1, "Supplier must be selected").nullable(),
    completed: z.string({
        required_error: "Completion status must be specified",
    }),
    invoice_number: z.string().min(1, "Invoice number is required"),
    type: z.string().min(1, "Invoice type is required"),
    invoice_amount: z
        .number({
            required_error: "Invoice amount is required",
            invalid_type_error: "Invoice amount must be a valid number",
        })
        .nonnegative("Invoice amount cannot be negative"),
    invoice_vat: z
        .number({
            required_error: "VAT amount is required",
            invalid_type_error: "VAT amount must be a valid number",
        })
        .min(0, "VAT cannot be negative"),
    invoice_date: z
        .string()
        .min(1, "Invoice date is required")
        .refine((date) => !isNaN(Date.parse(date)), {
            message: "Invoice date must be a valid date",
        }),
    invoice_due_period: z.string().default("CUSTOM_PERIOD"),
    invoice_due_date: z.string().min(1, "Invoice Due Date is required"),
    invoice_paid: z.string().nullable(),
    invoice_paid_amount: z.number().nullable(),
    reference_number: z.string().min(1, "Reference number is required"),
    months_and_year_against_time_sheet: z
        .string()
        .min(1, "Month must be added"),
    invoice_receipt: z
        .instanceof(FileList, {
            message: "Invoice receipt must be a valid file",
        })
        .optional(),
    remarks: z.string(),
});

export const UpdateInvoiceSchema = CreateInvoiceSchema.extend({
    invoice_receipt: z.array(z.string()).nullable(),
    file: z.instanceof(FileList).nullable().optional(),
});

export const InvoiceFormSchema = CreateInvoiceSchema.extend({
    file: z.instanceof(FileList).nullable().optional(),
    existing_invoice_receipt: z.array(z.string()).optional(),
}).omit({
    invoice_receipt: true,
});

export type CreateInvoiceSchema = z.infer<typeof CreateInvoiceSchema>;

export type UpdateInvoiceSchema = z.infer<typeof UpdateInvoiceSchema>;

export type InvoiceFormSchema = z.infer<typeof InvoiceFormSchema>;
